var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getDataValue, removeDataValue, setDataValue } from '@juvare/json-data-util';
import React from 'react';
import { QuickFilterMultiSelect } from '../components';
import { getItems } from './getItems';
import { getSafeValueProvider } from './getSafeValueProvider';
export function quickFilterMultiSelect(params) {
    const safeValueProvider = getSafeValueProvider(params.valueProvider);
    return {
        quickFilter: {
            render: (props) => (React.createElement(QuickFilterMultiSelect, Object.assign({}, props, { dataPath: params.dataPath, label: params.label, values: params.values, valueProviderType: params.valueProviderType, valueProvider: safeValueProvider, sx: params.sx, "data-test": params.dataTest }))),
            dataPath: params.dataPath,
        },
        widgetConfig: params.widget === 'form.checkboxList'
            ? {
                type: 'form.checkboxList',
                key: params.dataPath,
                label: params.label,
                values: params.values,
                valueProvider: (safeValueProvider === null || safeValueProvider === void 0 ? void 0 : safeValueProvider.type) || params.valueProviderType
                    ? {
                        type: (safeValueProvider === null || safeValueProvider === void 0 ? void 0 : safeValueProvider.type) || params.valueProviderType,
                        params: safeValueProvider === null || safeValueProvider === void 0 ? void 0 : safeValueProvider.params,
                        paramsFromFormData: safeValueProvider === null || safeValueProvider === void 0 ? void 0 : safeValueProvider.paramsFromFormData,
                    }
                    : undefined,
                style: {
                    layout: '2-columns-stretch',
                },
            }
            : {
                type: 'form.multiSelect',
                key: params.dataPath,
                label: params.label,
                values: params.values,
                valueProvider: (safeValueProvider === null || safeValueProvider === void 0 ? void 0 : safeValueProvider.type) || params.valueProviderType
                    ? {
                        type: (safeValueProvider === null || safeValueProvider === void 0 ? void 0 : safeValueProvider.type) || params.valueProviderType,
                        params: safeValueProvider === null || safeValueProvider === void 0 ? void 0 : safeValueProvider.params,
                        paramsFromFormData: safeValueProvider === null || safeValueProvider === void 0 ? void 0 : safeValueProvider.paramsFromFormData,
                    }
                    : undefined,
                style: {
                    labelInPlaceholder: true,
                },
            },
        getFilterChips: (filterData) => __awaiter(this, void 0, void 0, function* () {
            const values = getDataValue(filterData, params.dataPath);
            if (Array.isArray(values) && values.length > 0) {
                const items = yield getItems({
                    values: params.values,
                    valueProviderType: params.valueProviderType,
                    valueProvider: safeValueProvider,
                    valueProvidersFromProps: params.valueProviders,
                    filterData,
                    formConfigContext: params.formConfigContext,
                });
                return values.map((value) => {
                    var _a, _b;
                    const label = (_b = (_a = items.find((item) => item.value === value)) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : value;
                    return {
                        label,
                        value,
                        onRemoveChip: (chipFilterData, chipValue) => handleRemoveChip(chipFilterData, params.dataPath, chipValue),
                        groupId: params.dataPath,
                    };
                });
            }
            else {
                return [];
            }
        }),
    };
}
function handleRemoveChip(filterData, dataPath, valueToRemove) {
    const newFilterData = JSON.parse(JSON.stringify(filterData));
    let newValues = getDataValue(newFilterData, dataPath);
    if (Array.isArray(newValues)) {
        newValues = newValues.filter((value) => value !== valueToRemove);
        if (newValues.length > 0) {
            setDataValue(newFilterData, dataPath, newValues);
        }
        else {
            removeDataValue(newFilterData, dataPath);
        }
    }
    return newFilterData;
}
